import { t } from 'ttag'
import PropTypes from 'prop-types'

import { Heading } from '@h2/components/typography/heading'
import { Text } from '@h2/components/typography/text'
import navigatorAccountSvg from '@h2/assets/svg/illustrations/navigatorAccount.svg'

import { Wrap } from './components'

const navigators = {
  educator: t`an Educator`,
  counselor: t`a Career Counselor`,
  family: t`a Family Member`
}
const Navigator = ({ type }) => {
  return (
    <Wrap>
      <Heading level="2" color="white" id="modal-title">
        <span>{t`Create an account`}</span>
        <span>{t`You are creating ${navigators[type]} Navigator account`}</span>
      </Heading>
      <Text color="white">
        {t`Complete the options on the right-hand side to help us optimize your account and start helping your explorers.`}
      </Text>
      <img src={navigatorAccountSvg} width="100%" height="auto" alt="" />
    </Wrap>
  )
}

Navigator.propTypes = {
  type: PropTypes.oneOf(Object.keys(navigators))
}

export { Navigator, navigators }
